import {NinchatProperties} from '../api/types'
import {TagProps} from '../components/Tag/types'

interface Props {
    tags: {
        [key: NinchatProperties.TagID]: NinchatProperties.NinchatTag,
    }
    tagIds?: NinchatProperties.TagID[]
}

interface TagsType {
    [key: NinchatProperties.TagID]: TagProps
}

export const mapTags = (props: Props): TagsType => {
    const {
        tags,
        tagIds,
    } = props

    const filtered: TagsType = {}

    Object.keys(tags).map((tag_id) => {
        if (tags[tag_id].tag_children && Object.keys(tags[tag_id].tag_children).length > 0) {
            const parentTag = tags[tag_id] as TagProps

            if (tagIds?.includes(tag_id)) {
                filtered[tag_id] = tags[tag_id] as TagProps
            }

            Object.keys(parentTag.tag_children).map((child_id) => {
                const childTag = parentTag.tag_children[child_id] as TagProps

                if (tagIds?.includes(child_id)) {
                    filtered[child_id] = {
                        ...childTag,
                        ...parentTag.tag_attrs?.name && {parentName: parentTag.tag_attrs?.name},
                    }
                }

                return null
            })
        } else if (tagIds?.includes(tag_id)) {
            filtered[tag_id] = tags[tag_id] as TagProps
        }

        return null
    })

    return filtered
}
